import type { DocNode } from '@atlaskit/adf-schema';

/**
 * Detects if a value already looks like an ADF DocNode (vs. a Lumina markup string).
 */
export const isAdfDoc = (value: unknown): value is DocNode => {
	return (
		typeof value === 'object' &&
		value !== null &&
		(value as DocNode).type === 'doc' &&
		Array.isArray((value as DocNode).content)
	);
};
